// extracted by mini-css-extract-plugin
export var attachment = "_po-a";
export var emailContainer = "_po-4";
export var emailContentPaddedContainer = "_po-b";
export var emailHeader = "_po-6";
export var emailIframe = "_po-3";
export var emailInfoIcon = "_po-9";
export var emailShortenedSummary = "_po-e";
export var infoDropdown = "_po-0";
export var infoRowBoundedContent = "_po-d";
export var internal = "_po-5";
export var merchant = "_po-8";
export var messageInputContainer = "_po-h";
export var normal = "_po-7";
export var replyCard = "_po-f";
export var subtleButton = "_po-1";
export var subtleButtonIconContainer = "_po-2";
export var toggleViewRepliesButton = "_po-c";
export var wrappingText = "_po-g";